<template>
  <div class="parallelogram-wrapper">
    <div
      class="parallelogram"
      v-if="vista && vista.config && vista.config.paso"
      :style="{ width: (vista.config.paso / config.cantPasos) * 100 + '%' }"
    />
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  data() {
    return {
      vista: null
    };
  },
  mounted() {
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        this.vista = route.meta;
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
.parallelogram {
  height: 8px;
  border: none;
  font: normal 100% / normal Arial, Helvetica, sans-serif;
  color: rgba(0, 0, 0, 1);
  -o-text-overflow: clip;
  text-overflow: clip;
  background: #2dcccd;
  -webkit-transform: translateX(-5px) skewX(-20deg);
  transform: translateX(-5px) skewX(25deg);
}

.parallelogram-wrapper {
  background-color: #d3d3d3;
  margin: 0 -20px;
}
</style>
